import { TransportMode } from '../../../../../../common/constants/transport-mode';
import { LocalDate, ShipmentDeviationType } from '../../../../../models';
import { MonitoringContentType } from '../../../../../constants';
import { ShipmentAlert } from '../../../models/shipment-common-models/shipment-alert.model';
import { ShipmentOrigin } from '../../../transport';
import { ListServerPaginationStateModel } from '../../../../../../common';
import { ShipmentIdView } from '../../../models/shipment-common-models/shipment-id-view.model';
import { ShipmentArrivalDatesModel } from '../../../models/shipment-common-models/shipment-arrival-dates.model';
import { ShipmentDeliveryDatesModel } from '../../../models/shipment-common-models/shipment-delivery-dates.model';
import { PickUpDeliveryInfo } from '../../../models/shipment-common-models/shipment-pickup-delivery-info.model';
import { ShipmentQuickFilterModel } from '../../../models/shipment-common-models/shipment-quick-filter.model';
import { ShipmentSapUpdateStatus } from '../../constants/shipment-sap-update-status.constant';

export interface ShipmentMaterialModel {
  materialNumber: string;
  quantity: number;
}

export interface ShipmentHandlingUnitModel {
  idView: {
    huId: string;
    deliveryNoteNumber: string;
  };
  deviationType: ShipmentDeviationType;
  arrivalDates: ShipmentArrivalDatesModel;
  lastStatus: string;
}

export class Shipment {
  idView: ShipmentIdView;
  type: MonitoringContentType;
  reference: string;
  additionalReference: string;
  pickUp: PickUpDeliveryInfo = null;
  delivery: PickUpDeliveryInfo = null;
  transportMode: TransportMode = null;
  carrier = '';
  lastStatus = '';
  arrivalDates: ShipmentArrivalDatesModel | null = null;
  deliveryDates: ShipmentDeliveryDatesModel | null = null;
  deviationType: ShipmentDeviationType = null;
  materials: ShipmentMaterialModel[] = null;
  alert: {
    active: boolean;
    hasCritical: boolean;
    events: ShipmentAlert[];
  };
  origin: ShipmentOrigin = null;
  hasNotification: boolean;
  handlingUnits: ShipmentHandlingUnitModel[] = [];
  sapUpdateStatus: ShipmentSapUpdateStatus | null = null;
  lastEtaUpdateInSapTime: LocalDate | null = null;

  constructor(params?: Partial<Shipment>) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export type ShipmentListDto = Omit<ListServerPaginationStateModel<Shipment>, 'loaded'>;

export type ShipmentStatisticsModel = {
  milestones: ShipmentQuickFilterModel[];
  deviations: ShipmentQuickFilterModel[];
  infos: ShipmentQuickFilterModel[];
};

export type ShipmentListModel = {
  shipments: ShipmentListDto;
  mapThreshold: number;
};
